export default __webpack_public_path__ + "static/media/83.c1e1e536.png";